<script>
    import {generic_validation} from "../globals.js";
    import {api_host, doToast} from "../stores.js";

    import {querystring} from 'svelte-spa-router'
    import { onDestroy, onMount } from 'svelte';
    import Header from "./header.svelte";
    import breakpoints from "../utils/breakpoints";
    import {link, location, push, pop, replace} from 'svelte-spa-router';

    import IFTAInput from "../utils/iftainput.svelte";
    import CreditCardEntry from "../utils/creditcardentry.svelte";
    import Itemselector from "../utils/itemselector.svelte";

    import validate from 'validate.js';
    import { curry } from 'ramda';

    let content_title = "Price Test";
    let jid = "";
    let is_busy = false;

    // lifecycle items
    onMount(async () => {
        // const params = new URLSearchParams($querystring)
        // if (params.has("jid")) {
        //     jid = params.get("jid");
        // }

    });


    const constraints = {
        // "cc_number": {
        //     format: {
        //       pattern: /^$|^(34|37|4|5[1-5]).*$/,
        //       message: function(value, attribute, validatorOptions, attributes, globalOptions) {
        //         return validate.format("^%{num} is not a valid credit card number", {num: value});
        //       }
        //     }
        // },
        // "CVC": {
        //     format: {
        //         pattern: /^$|^\d{3,4}$/,
        //         message: "should be a 3 or 4 digit number."
        //     }
        // },
        // "Expiration date": {
        //     format: {
        //         pattern: /^$|^\d\d\/?2\d/,
        //         message: "date format should be MM/YY"
        //     }
        // }
    };


    let cgv = curry(generic_validation);
    let curried_gv = cgv(constraints);

    let fields = [
        {
            "index": 0,
            "group": "pricetesting",
            "type": "text",
            "label": "Lot Size",
            "value": "",
            "placeholder": "eg. 8000, 10000..."
        },

        {
            "index": 1,
            "group": "pricetesting",
            "type": "select",
            "label": "Lawn",
            "value": "Front and Back",
            "select_options": ['Front and Back', 'Front or Back', 'None'],
        },
        {
            "index": 2,
            "group": "pricetesting",
            "type": "select",
            "label": "Service",
            "value": "Weekly",
            "select_options": ['Weekly', 'Bi-Weekly', 'Monthly', 'One-Time', 'Every 3 weeks', 'Every 6 weeks', 'Every 2 months' ],
        },
        {
            "index": 3,
            "group": "pricetesting",
            "type": "select",
            "label": "Stories",
            "value": "1",
            "select_options": ['1', '2', '3'],
        },
        {
            "index": 4,
            "group": "pricetesting",
            "type": "select",
            "label": "Last Cleanup?",
            "value": "Less than 2 weeks ago",
            "select_options": ['Less than 2 weeks ago', '2 to 4 weeks ago', '1 to 2 months ago', '3 months or more'],
        },

    ];

    let validateForm = () => {
        console.log("validating form");
        let is_valid = true;
        for(let i = 0; i < fields.length; i++) {
            // console.log(fields[i]);
            let tfv = fields[i].ext_funcs.validateForm();
            if(!tfv) {
                is_valid = false;
            }
        }
        
        return is_valid;
    };
    
    let doPriceTest = () => {
        if(validateForm()) {
            $doToast("Would be testing price here.", "info");
        }else{
            $doToast("Form failed validation.", "error");
        }
    };

</script>

<Header bind:title={content_title} bind:is_busy={is_busy} />

<div class="contentholder">

    <div class="section pricetestinginfo">
        <div class="sectioninfo">

            <div class="ff rowwrap">
                {#each fields.filter((e)=>e.group === "pricetesting") as nf}
                <IFTAInput 
                type={(nf.type !== undefined) ? nf.type : ""} 
                label={(nf.label !== undefined) ? nf.label : ""} 
                placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
                bind:value={nf.value}
                bind:validation_function={nf.validation_function}
                bind:extFuncs={nf.ext_funcs} />
                {/each}
            </div>



        </div>
    </div>

    <div class="section updatebuttonholder">
        <div class="updatebutton">
            <button on:click={() => {doPriceTest();}}>Test It!</button>
        </div>
        <div class="backbutton">
            <button on:click={()=>{pop();}}><i class="fas fa-arrow-circle-left"></i> Back</button>
        </div>
        <!-- <div class="bookinglinkbutton">
            <button><i class="fas fa-link"></i> Create Booking Link</button>
        </div> -->

    </div>

</div>

<style>
    .ff {
        padding: 10px;
        width: 100%;
    }
    :global(.ff .group) {
        margin-left: 5px;
        margin-right: 5px;
    }
    .formrow {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }


    .section_old {
        width: 100%;
    }

    .section_old .sectiontitle_old {
        width: 100%;
        font-size: 20px;
        color: white;
        background-color: #1769aa;
        margin-bottom: 10px;
    }
    .section_old .sectiontitle_old i{
        width: 25px;
        display: none;

    }
    .sectioninfo {
        width: 100%;
    }

    .contentholder {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        grid-template-rows: auto;
        grid-template-areas: "pi pi pi pi pi pi pi pi pi pi pi pi"
                             "ub ub ub ub ub ub ub ub ub ub ub ub";
        gap: 20px;
    }

    .pricetestinginfo {
        grid-area: pi;
    }
    .updatebuttonholder {
        grid-area: ub;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }
    .updatebuttonholder button {
        width: 200px;
        margin-right: 10px;
    }
    .updatebutton button {
        background-color: #357a38;
        color: white;
    }
    .backbutton button {
        background-color: #ff9100;
        color: white;
    }
    .bookinglinkbutton button {
        background-color: #1769aa;
        color: white;
    }

    .mockgroupitem {
        width: 100%;
        border: solid 1px #ccc;
        border-radius:6px;
        padding-top: 15px;
        padding-bottom: 15px;
    }

    @media (max-device-width: 1024px), (max-width: 1023px) {
        .ff {
            padding: 10px;
            width: 100%;
        }
        .formrow {
            width: 100%;
            padding: 0px;
            display: flex;
            flex-direction: column;
        }

        .section_old {
            padding: 0px;
        }
        .contentholder {
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            grid-template-rows: auto;
            grid-template-areas: "pi"
                                 "ub";
            gap: 20px;

        }

        .updatebuttonholder {
            grid-area: ub;
            width: 100%;
            display: flex;
            flex-direction: column;
            
        }
        .updatebuttonholder button {
            width: 100%;
            margin-right: 10px;
        }
        .updatebutton button {
            background-color: #357a38;
            color: white;
        }
        .backbutton button {
            background-color: #ff9100;
            color: white;
        }
        .bookinglinkbutton button {
            background-color: #1769aa;
            color: white;
        }


    }

</style>